export default __webpack_public_path__ + "static/media/uploader-oneTouchUltra2-3.d5234a3c.png";